import * as z from "zod";

import { REQUIRED_MESSAGE, requiredNumber, requiredString } from "components/form/utils";

export const referenceObject = () =>
    z
        .object({
            id: requiredString(),
        })
        .or(z.literal(undefined))
        .or(z.literal(null))
        .or(z.literal(""))
        .refine((val) => !!val && !!val.id?.trim(), {
            message: REQUIRED_MESSAGE,
        });

export const applicantSchema = z.object({
    opening: requiredString(),
    employee: referenceObject(),
    resume_url: z.string().optional().nullable(),
    is_selected: z.boolean().optional().nullable(),
    experience: requiredNumber(),
});
